/* index.js */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Initialize as GA_Initialize } from './helpers/GoogleAnalytics';

GA_Initialize();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
